(function () {
    var PagePrint;

    window.PagePrint = PagePrint = (function () {
        var appendToPrintTable, checkCurrentTableHeight, cloneEmptyTable, configureForPrint, createPrintTable, debugOutput, debugRow, getFooter, getLastTableRow, getRepeaterType, padTables, processColumnTables, resizePageSizeFromPageHeightClass, scanPrintBody, scanPrintHidden, scanPrintNewPage, scanPrintRepeater, scanPrintTableRepeater, setPageNumbers, setPrintDate, _debugOutput, _footer, _header, _pageHeight, _pageWidth, _printDate;

        _pageHeight = 1480;

        _debugOutput = false;

        _printDate = '';

        _header = '<div style="height:80px;display:block;" class="printHeader"><h1>HEADER</h1></div>';

        _footer = '<div style="border-top: 1px solid black; padding-top:6px; height:43px;" class="printFooter container"><div class="row"><div class="threecol"></div><div class="sixcol _pageNumber" style="text-align:center;height: 15px;"></div><div class="threecol last" style="text-align:right;">{{dateReplace}}</div></div></div>';

        function PagePrint(pageHeight, header, footer) {
            if (pageHeight) {
                if (pageHeight < 500)
                    _pageHeight = 500;
                else
                    _pageHeight = pageHeight;
            }

            if (header && header.length > 0) {
                _header = header;
            } else if ($('.print-header').length === 1) {
                _header = $('.print-header').clone().wrap('<div>').parent().html();
            }

            if (footer && footer.length > 0) {
                _footer = footer;
            } else if ($('.print-footer').length === 1) {
                if ($('.print-footer').hasClass('hide'))
                    _footer = '';
                _footer = $('.print-footer').clone().wrap('<div>').parent().html();
            }

            configureForPrint();
        }

        setPageNumbers = function () {
            var noOfPages, page, _i, _len, _ref, _results;
            noOfPages = $('._pageNumber').length;
            _ref = $('._pageNumber');
            _results = [];
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                page = _ref[_i];
                _results.push($(page).html('Page ' + (_i + 1) + ' of ' + noOfPages));
            }
            return _results;
        };

        resizePageSizeFromPageHeightClass = function (classList) {
            var classItem, pageHeight, _i, _len, _results;
            pageHeight = 'printPageHeight';
            _results = [];
            for (_i = 0, _len = classList.length; _i < _len; _i++) {
                classItem = classList[_i];
                if (classItem.substring(0, pageHeight.length) === pageHeight) {
                    _pageHeight = parseInt(classItem.substring(pageHeight.length, classItem.length));
                    _results.push($($('.printTable').last()).css('height', _pageHeight + 'px'));
                } else {
                    _results.push(void 0);
                }
            }
            return _results;
        };

        getRepeaterType = function (e) {
            var classItem, classList, eClass, parentClass, _i, _len;
            eClass = $(e).attr('class');
            classList = [];
            if (eClass && eClass.length > 0) {
                classList = $(e).attr('class').split(/\s+/);
            } else {
                parentClass = $(e).parent().attr('class');
                if (parentClass === 'rationale') {
                    classList = ['printRepeater'];
                }
            }
            if (classList.length > 0) {
                resizePageSizeFromPageHeightClass(classList);
                for (_i = 0, _len = classList.length; _i < _len; _i++) {
                    classItem = classList[_i];
                    if (classItem === 'printRepeater' || classItem === 'rationale') {
                        return 'printRepeater';
                    }
                    if (classItem === 'printTableRepeater') {
                        return 'printTableRepeater';
                    }
                    if (classItem === 'printNewPage') {
                        return 'printNewPage';
                    }
                    if (classItem === 'printHidden') {
                        return 'printHidden';
                    }
                    if (classItem === 'printHeaderFixed') {
                        return 'printHeaderFixed';
                    }
                }
            }
            return '';
        };

        checkCurrentTableHeight = function (table) {
            return table.outerHeight(true) > _pageHeight;
        };

        getFooter = function () {
            _footer = _footer.replace('{{dateReplace}}', _printDate);
            return _footer;
        };

        createPrintTableHeaderFixed = function () {
            var table = $('.printTableHeaderFixed');
            if (table.length === 0) {
                table = $('<table class="printTableHeaderFixed"><tbody class="printBody"></tbody></table>');
                $('body div.pageDetails').prepend(table);
            }
            return table;
        };

        createPrintTable = function () {
            var table, header, footer;
            if (_header.length > 0)
                header = '<thead><tr class="printRow"><td class="printCell">' + _header + '</tr></td></thead>';
            if (_footer.length > 0)
                footer = '<tfoot><tr class="printRow"><td class="printCell">' + getFooter() + '</td></tr></tfoot>';

            table = $('<table style="height:' + _pageHeight + 'px;" class="printTable">' + header + '<tbody class="printBody"></tbody>' + footer + '</table>');
            $('body div.pageDetails').append(table);
            return table;
        };

        appendToPrintTable = function (printTable, element) {
            return $(printTable).children('tbody').append($('<tr class="printRow"></tr>').append($('<td class="printCell"></td>').append(element)));
        };

        padTables = function () {
            var height, item, items, printTable, printTables, _i, _j, _len, _len1, _results, _tableUsedHeight;
            printTables = $('table.printTable');
            _results = [];
            for (_i = 0, _len = printTables.length; _i < _len; _i++) {
                printTable = printTables[_i];
                items = $(printTable).children('tbody').children('tr').children('td').children();
                if (items.length > 0) {
                    height = 0;
                    for (_j = 0, _len1 = items.length; _j < _len1; _j++) {
                        item = items[_j];
                        height += $(item).outerHeight(true);
                    }
                    _results.push(appendToPrintTable(printTable, $('<div></div>').css('height', ($(printTable).children('tbody').outerHeight() - height) + 'px')));
                } else {
                    _results.push(void 0);
                }

                //_tableUsedHeight = $(printTable).find('> thead').outerHeight(true);
                //_tableUsedHeight += $(printTable).find('> tbody').outerHeight(true);
                //_tableUsedHeight += $(printTable).find('> tfoot').outerHeight(true);
                //_results.push(appendToPrintTable(printTable, $('<div></div>').css('height', $(printTable).outerHeight(true) - _tableUsedHeight + 'px')));
            }
            return _results;
        };

        getLastTableRow = function (table) {
            return $(table).children('tbody').children('tr').last();
        };

        debugOutput = function (table) {
            var lastRow;
            if (_debugOutput) {
                lastRow = getLastTableRow(table);
                console.log($(lastRow).outerHeight(true) + ' x ' + $(lastRow).outerWidth(true) + ': ' + $('table.printTable').length);
                return $('body').prepend($('<div style="z-index:99999;position:absolute;top:' + $(lastRow).position().top + 'px;">' + $(table).outerHeight(true) + ' - ' + $(lastRow).outerHeight(true) + ' x ' + $(lastRow).outerWidth(true) + ': ' + $('table.printTable').length + ': ' + $('table.printTable thead').outerHeight(true) + ': ' + $('table.printTable tbody').outerHeight(true) + ': ' + $('table.printTable tfoot').outerHeight(true) + '</div>'));
            }
        };

        debugRow = function (row) {
            if (_debugOutput) {
                var table = $(row).parents('table');
                console.debug('row: ' + $(row).outerHeight(true));
                $('body').prepend($('<div style="z-index:99999;position:absolute;top:' + ($(row).position().top) + 'px;">' + $(table).outerHeight(true) + ' - ' + $(row).outerHeight(true) + ' x ' + $(row).outerWidth(true) + ': ' + $('table.printTable').length + ': ' + $('table.printTable thead').outerHeight(true) + ': ' + $('table.printTable tbody').outerHeight(true) + ': ' + $('table.printTable tfoot').outerHeight(true) + '</div>'));
                var tds = $(row).children('td');
                for (var i = 0; i < tds.length; i++) {
                    var td = tds[i];
                    $('body').prepend($('<div style="z-index:99999;position:absolute;top:' + ($(td).position().top) + 'px;right:' + ($(td).position().right) + '">' + $(td).outerHeight(true) + '</div>'));
                }
            }
        };

        scanPrintRepeater = function (table, element) {
            var tr;
            appendToPrintTable(table, element);
            debugOutput(table);
            if (checkCurrentTableHeight(table)) {
                tr = table.children('tbody').children('tr').last();
                getLastTableRow(table).remove();
                table = createPrintTable();
                table.children('tbody').append(tr);
                debugOutput(table);
            }
            return table;
        };

        cloneEmptyTable = function (table) {
            var newTable;
            newTable = $(table).clone();
            $(newTable).children('tbody').children('tr').remove();
            return newTable;
        };

        scanPrintTableRepeater = function (printTable, element) {
            var clonedTable, row, rows, _i, _len;
            rows = $(element).children('tbody').children('tr');
            clonedTable = cloneEmptyTable(element);
            appendToPrintTable(printTable, clonedTable);
            if (checkCurrentTableHeight(printTable)) {
                $(printTable).remove();
                printTable = createPrintTable();
                scanPrintTableRepeater(printTable, element);
                debugOutput(printTable);
            }
            for (_i = 0, _len = rows.length; _i < _len; _i++) {
                row = rows[_i];
                $(clonedTable).children('tbody').append(row);
                if (checkCurrentTableHeight(printTable)) {
                    getLastTableRow(clonedTable).remove();
                    $(element).children('tbody').prepend(row);
                    printTable = createPrintTable();
                    scanPrintTableRepeater(printTable, element);
                    debugOutput(printTable);
                    break;
                } else {
                    debugRow(row);
                }
            }
            return $('.printTable').last();
        };

        scanPrintNewPage = function () {
            return createPrintTable();
        };

        scanPrintHidden = function (element) {
            return $('body.print').prepend(element);
        };

        scanPrintHeaderFixed = function (element) {
            var table = createPrintTableHeaderFixed();
            appendToPrintTable(table, element);
        };

        scanPrintBody = function () {
            var printTable, repeater, repeaterType, repeaters, _i, _len, _results;
            $('body.print .printShow').show();
            repeaters = $('body.print .printRepeater, body.print .printTableRepeater, body.print .printNewPage, body.print .printHidden, body.print .printHeaderFixed');
            $('body div.pageDetails').children().remove();
            printTable = createPrintTable();
            _results = [];
            for (_i = 0, _len = repeaters.length; _i < _len; _i++) {
                repeater = repeaters[_i];
                repeaterType = getRepeaterType(repeater);
                if (repeaterType === 'printRepeater') {
                    _results.push(printTable = scanPrintRepeater(printTable, repeater));
                } else if (repeaterType === 'printTableRepeater') {
                    _results.push(printTable = scanPrintTableRepeater(printTable, repeater));
                } else if (repeaterType === 'printNewPage') {
                    _results.push(printTable = scanPrintNewPage(repeater));
                } else if (repeaterType === 'printHidden') {
                    _results.push(scanPrintHidden(repeater));
                } else if (repeaterType === 'printHeaderFixed') {
                    _results.push(scanPrintHeaderFixed(repeater));
                } else {
                    _results.push(void 0);
                }
            }
            return _results;
        };

        setPrintDate = function () {
            var printDate;
            printDate = $('input[type="hidden"]#PrintDate');
            if (printDate.length > 0) {
                _printDate = printDate.val();
                return _printDate;
            }
        };

        configureForPrint = function () {
            setPrintDate();
            scanPrintBody();
            /*
                  $('body').append($('<div style="position:absolute; top:0px;">' + ($($('.printFooter')[0]).position().top + $($('.printFooter')[0]).outerHeight() + '</div>')))
            */

            padTables();
            setPageNumbers();
            return true;
        };

        return PagePrint;

    })();

}).call(this);